<nav class="main-navbar">
  <div class="main-navbar-container">
    <app-user-header-info [currentUser]="activeUser$ | async" [businessAccountId]="businessAccountId$ | async"></app-user-header-info>
  </div>
</nav>
